

new Swiper('.video-slider', {
     navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
     },
     breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 10,
        },
        580: {
          slidesPerView: 2.1,
          spaceBetween: 10,
        },
        767: {
          slidesPerView: 3.1,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 4.1,
          spaceBetween: 10,
        },
        1400: {
          slidesPerView: 5.1,
          spaceBetween: 10,
        },
     },
});


  $('.video').parent().click(function () {
  if($(this).children(".video").get(0).paused){        $(this).children(".video").get(0).play();   $(this).children(".playpause").fadeOut();
    }else{       $(this).children(".video").get(0).pause();
  $(this).children(".playpause").fadeIn();
    }
});
